const pageSmallSizeTable = 10;
const pageDefaultSizeTable = 12;
const normalCharactersLength = 120;
const mediumCharactersLength = 250;
/** Long text fields (Assignment Information; Financial: credit notes, invoice periods) — MDB-144 / MDB-226 */
const assignmentRequirementLongTextMaxLength = 10000;
const dunsNumberMaxLength = 20;
const payorNameMaxLength = 50;

const countryUSAid = 184;
const countryAustraliaId = 10;
const countryMexicoId = 110;
const countryCanadaId = 32;
const IDLE_TIMEOUT = 30 * 60 * 1000;

export { MEMBER_PRICE_AGREEMENT_MAX_FILES } from './fileUploadLimits';

export {
  pageSmallSizeTable,
  normalCharactersLength,
  mediumCharactersLength,
  assignmentRequirementLongTextMaxLength,
  dunsNumberMaxLength,
  payorNameMaxLength,
  pageDefaultSizeTable,
  countryUSAid,
  countryAustraliaId,
  countryMexicoId,
  countryCanadaId,
  IDLE_TIMEOUT,
};
